import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants, FormatConstants } from "services/keyConstants";
import { getStatusTypes } from "./service";
import { feedbackDownload, feedbackList } from "api/module/feedback";
import { Copy } from "iconsax-react";
import { showToast } from "services/utils";
import { universalCopy } from "services/utils";

// Lazy-loaded components
const Create = Loadable(lazy(() => import("../Create")));
const ViewById = Loadable(lazy(() => import("../ViewById")));
const CommonDetail = Loadable(
  lazy(() => import("components/CommonDetail/CommonDetail"))
);

const FeedbackRoutes = [
  {
    path: routeConstants.FEEDBACK,
    children: [
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item, filterData) => {
                const basePath = `/${routeConstants.FEEDBACK}/${item?._id}`;
                return filterData?.current?.type === "Generate-Link" &&
                  item?.mainId
                  ? `${basePath}/${item?.mainId}`
                  : basePath;
              },
            }}
            url={{ GET: feedbackList, DOWNLOAD: feedbackDownload }}
            getStatusTypes={getStatusTypes}
            filterOptions={{
              [FormatConstants.FEEDBACK.INTERNAL_FEEDBACK]: [
                { name: "Status", optionsKey: "statusOptions" },
              ],
              [FormatConstants.FEEDBACK.EXTERNAL_FEEDBACK]: [
                { name: "Status", optionsKey: "statusOptions" },
                { name: "Type", optionsKey: "typeOptions", isHiddenAll: true },
              ],
            }}
            downloadConfig={(defaultMasterDocData, item) => {
              if (
                defaultMasterDocData?.defaultName ===
                FormatConstants.FEEDBACK.EXTERNAL_FEEDBACK
              ) {
                return { _id: item?.mainId };
              }
              return {};
            }}
            tableConfig={(defaultMasterDocData, filterData, userData, rows) => {
              return {
                defaultActions: [
                  {
                    tooltip: "Copy the Link",
                    color: "primary",
                    icon: <Copy />,
                    isCustomRoute: true,
                    onClick: async (item) => {
                      const ok = await universalCopy(item?.domainLink);
                      showToast(
                        ok ? "Link Copied Successfully" : "Copy Failed",
                        ok
                      );
                    },
                    isVisible: (item) => {
                      const result = item?.status === "Initiated";
                      return result;
                    },
                  },
                ],
                downloadActionConfig: {
                  isVisible: (item) => {
                    const result = item?.status !== "Initiated";
                    return result;
                  },
                },
                viewActionConfig: {
                  isVisible: (item) => {
                    const result = item?.status !== "Initiated";
                    return result;
                  },
                },
                chip: {
                  status: (data) => {
                    let color =
                      data?.row?.status === "Pending"
                        ? "warning"
                        : data?.row?.status === "Negative"
                        ? "error"
                        : "success";
                    return {
                      label: data?.row?.status,
                      color: color,
                    };
                  },
                },
              };
            }}
          />
        ),
      },
      {
        path: "create-internal",
        element: <Create type={FormatConstants.FEEDBACK.INTERNAL_FEEDBACK} />,
      },
      {
        path: "create-external",
        element: <Create type={FormatConstants.FEEDBACK.EXTERNAL_FEEDBACK} />,
      },
      {
        path: ":id/:subId?",
        element: <ViewById />,
      },
    ],
  },
];

export default FeedbackRoutes;
